import { Component, inject } from '@angular/core';
import { IPaymentRecord } from '@luggagehero/shared/interfaces';
import { SharedLoggingService } from '@luggagehero/shared/services/logging';
import { SharedPaymentService } from '@luggagehero/shared/services/payments';

import { BookingActionBaseComponent } from './booking-action.base-component';

@Component({
  template: '',
  standalone: false,
})
export abstract class SelectPaymentMethodActionBaseComponent extends BookingActionBaseComponent {
  private paymentService = inject(SharedPaymentService);
  private log = inject(SharedLoggingService);

  private _paymentMethod: IPaymentRecord;
  private _paymentMethods: IPaymentRecord[];

  get hasChanged(): boolean {
    if (!this.paymentMethod || !this.booking) {
      return false;
    }
    return this.paymentMethod.id !== this.booking.paymentMethodId;
  }

  get paymentMethod(): IPaymentRecord {
    return this._paymentMethod;
  }
  set paymentMethod(value: IPaymentRecord) {
    this._paymentMethod = value;
    this.cd.markForCheck();
  }

  get paymentMethods(): IPaymentRecord[] {
    return this._paymentMethods;
  }
  set paymentMethods(value: IPaymentRecord[]) {
    this._paymentMethods = value;
    if (!this.booking || !this.booking.paymentMethodId) {
      return;
    }
    for (let i = 0; i < this.paymentMethods.length; i++) {
      if (this.paymentMethods[i].id === this.booking.paymentMethodId) {
        this.paymentMethod = this.paymentMethods[i];
        break;
      }
    }
  }

  get isPaymentDue(): boolean {
    if (!this.booking) {
      return false;
    }
    return ['CHECKED_IN', 'CHECKED_OUT'].includes(this.booking.status);
  }

  async onBaseInit() {
    try {
      // Bypass locally cached payment methods if payment has failed
      const noCache = this.booking.status === 'CHECKED_OUT';
      const res = await this.paymentService.getPaymentMethods(this.booking._id, noCache);
      this.paymentMethods = res || [];
    } catch {
      // TODO: Do not show internal error messages to user
      // this.errorOccurred = true;
      // this.errorMessage = err;
    }
    this.isLoading = false;
  }

  async confirm(): Promise<void> {
    if (this.paymentMethod.id === this.booking.paymentMethodId) {
      // No change in payment method
      return;
    }
    this.isLoading = true;

    try {
      const res = await this.bookingService.setPaymentMethod(this.booking._id, this.paymentMethod.id);

      void this.log.debug(`Payment method successfully set on booking`);
      this.updateBooking(res);

      this.isLoading = false;
      this.close();
    } catch {
      // TODO: Handle errors
    }

    this.isLoading = false;
  }
}
